import { FC } from 'react';
import { Avatar, cn } from 'fe-learner-common';
import { TPerson } from '@api/io/session.io';

type PersonProps = {
  person: TPerson;
};

export const Person: FC<PersonProps> = ({ person }) => {
  return (
    <div
      className={cn(
        'relative flex items-center gap-4 rounded-lg border-1 border-neutral-200 p-2',
      )}
    >
      <Avatar
        size="lg"
        src={person.thumbnail || undefined}
        alt=""
        aria-hidden
      />
      <div className="flex flex-col items-start gap-1">
        <h3 className="text-label-lg ">{person.name}</h3>
      </div>
    </div>
  );
};
